import React from "react";
import moment from "moment";

import { formatWindowRange, TWindowDates } from "./withdrawalWindows";
import styles from "./fundForm.module.scss";

interface IWindowTimeline {
  start: moment.Moment;
  windows: TWindowDates[];
}

/**
 * The plan's start, its first windows and "and onward", on one track.
 *
 * The same picture the mobile app shows on the last step of Habit Save, used
 * by the form while a fund is set up and by the preview once it is saved.
 */
export default function WindowTimeline({ start, windows }: IWindowTimeline) {
  return (
    <div className={styles.timeline}>
      <div className={styles.timelineTrack} />
      <div className={styles.timelineStops}>
        <div className={styles.timelineStop}>
          <span
            className={styles.timelineDot}
            style={{ background: "#FFFFFF", borderColor: "#16054E" }}
          />
          <div style={{ textAlign: "center" }}>
            <div className={styles.timelineLabel} style={{ color: "#16054E" }}>
              Plan starts
            </div>
            <div className={styles.timelineDate}>
              {start.format("D MMM YYYY")}
            </div>
          </div>
        </div>

        {windows.map((window, index) => {
          const faded = index === windows.length - 1;
          const shade = faded ? "#C7B6FF" : "#713FFF";

          return (
            <div
              key={window.opens.toISOString()}
              className={styles.timelineStop}
            >
              <span
                className={styles.timelineDot}
                style={{ background: shade, borderColor: shade }}
              />
              <div style={{ textAlign: "center" }}>
                <div
                  className={styles.timelineLabel}
                  style={{ color: faded ? "#6B5AA0" : "#3F137D" }}
                >
                  Window {index + 1}
                </div>
                <div className={styles.timelineDate}>
                  {formatWindowRange(window)}
                </div>
              </div>
            </div>
          );
        })}

        <div className={styles.timelineStop}>
          <span
            className={styles.timelineDot}
            style={{ background: "#E7EAEF", borderColor: "#E7EAEF" }}
          />
          <div style={{ textAlign: "center" }}>
            <div className={styles.timelineDate} style={{ marginTop: 2 }}>
              and onward
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
